import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgStyle } from '@angular/common';
import { AuRoundAvatarComponent } from '../../au-round-avatar/au-round-avatar/au-round-avatar.component';
import { AuDataElementComponent } from './au-data-elemt/au-data-element.component';
import { IAssigneeUser } from '@shared/interfaces/selectable-options.interfaces';

@Component({
	selector: 'app-view-entity-component',
	templateUrl: './view-entity.component.html',
	styleUrls: ['./view-entity.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [AuRoundAvatarComponent, NgStyle, AuDataElementComponent],
})
export class ViewEntityComponent {
	@Input() avatarData: IAssigneeUser;
	@Input() repeatableItems: { data: string; label: string }[];
}
